import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit, DoCheck } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { ICardComponent } from '../../ICardComponent';
import { DomainCodes } from '../../../../models/const.DomainCodes';
import { CommonData } from '../../../_infrastructure/CommonData/CommonDataResolver';
import { isUndefined, isNullOrUndefined } from '../../../_infrastructure/objectUtils';
import { DocumentationVMExtension, DocumentVMExtension } from './IDocumentation';
import { confirmRemoveFromList } from '../../../_infrastructure/TableEdit/TableEditBase';
import { ModalService } from '../../../_infrastructure/Modal/ModalService';
import { SecurityService } from '../../../_infrastructure/Security/SecurityService';
import { WorkflowComponent } from '../../workflow.component';
  
import { StepDetailsService } from '../../../_infrastructure/StepDetailsService/StepDetailsService';

interface ResultDocumentVM {
  mandatoryFileAlreadyExists: boolean;
  indexOfMandatoryFileEntry: number;
}

@Component({
    selector: 'documentation',
    templateUrl: './documentation.component.html',
    standalone: false
})
export class DocumentationComponent implements OnInit, OnDestroy, ICardComponent, DoCheck {
  public cardData: DocumentationVMExtension = {} as DocumentationVMExtension;
  public cardConfiguration: models.CardVM;

  public expandedRowIndex: number = null;
  public expandNewEntry: boolean = false;

  @CommonData(DomainCodes.domains)
  public domains: models.DimensionVM[];
  @CommonData(DomainCodes.fileTypes)
  public fileTypes: models.DimensionVM[];
  @CommonData(DomainCodes.documentDesignationType)
  public designationTypes : models.DimensionVM[];
  public workflowInstanceId: string;

  public isWorkflowOnSubscriber: boolean = false;
  public isWorkflowIncapacity: boolean = false;
  public isMandatoryDocumentation: boolean;

  public parentWorkflow: WorkflowComponent;
  public workflowDropdowns: models.WorkflowDropdownsVM = <models.WorkflowDropdownsVM>{}

  public showAddDocButton: boolean = false;
  public userSendingClinicalDocs: boolean;
  public userSendingSSRegisterDate: boolean;
  public userSendingPensionsValue: boolean;
  public userSendingDisability: boolean;
  public userSendingPermanentDisability: boolean;
  public userSendingIBAN: boolean;
  public userSendingBiographicRegistry: boolean;
  public userSendingTeacherCert: boolean;
  public userSendingFiremenCert: boolean;
  public userSendingMilitaryCert: boolean;
  public version2: boolean;

  public professionalClass: string;

  public PGPAS: boolean;
  public isAtendimento: boolean;

  public initialMandatory: DocumentVMExtension[];

  public readonlyAdditionalDoc: boolean;
  constructor(
    private modalService: ModalService,
    private activeRoute: ActivatedRoute,
    private securityService: SecurityService
  ) {
    this.activeRoute.parent.paramMap.subscribe((params: ParamMap) => {
      this.workflowInstanceId = params.get('workflowInstanceId');
    });
  }

 
  ngOnInit(): void {
    this.PGPAS = this.parentWorkflow.workflowInstance.instanceRole.includes('006') ? true : this.parentWorkflow.workflowInstance.instanceRole.includes('007') ? false : null;
    this.isAtendimento = ((this.securityService.userDetails.informationGroups.includes("PGPA") ? "A" : null) == "A" ? true : false);

    if (this.isVersion2())
      this.workflowDropdowns = this.parentWorkflow.workflowDropdowns;

    const stepClinicalInfo = this.parentWorkflow.workflowInstance.formData?.StepClinicalInfo;

    if (!this.isVersion2()) {
      if (this.parentWorkflow.isWorkflowOnSubscriber) {
        this.userSendingClinicalDocs = true;
      } else {
        this.userSendingClinicalDocs = false;

        if (stepClinicalInfo) {
          this.userSendingClinicalDocs = (stepClinicalInfo['ClinicalSituation']?.clinicalSubscDoc == "true");
        }
        this.cardData.isMandatoryDocumentation = this.userSendingClinicalDocs;
      }
    }

    if (this.isVersion2()) {
      if (!this.checkSteps()) {
        this.professionalClass = this.parentWorkflow.workflowInstance.formData['StepSubscriberInfo']?.['CGAPensionStatus']?.professionalCategoryCode;
      } else {
        this.professionalClass = this.parentWorkflow.workflowInstance.formData['StepSubscriberCGA']?.['CGAPensionStatus']?.professionalCategoryCode;
      }

      // TEMP to prevent undefined errors if no stepdata is found
      if (isUndefined(this.cardData.documentsList))
        this.cardData.documentsList = [];

      let servDocArray: {}[] = [];
      if (this.parentWorkflow.workflowInstance.formData['StepDocuments']?.['ServDocumentation']?.['documentsList'])
        servDocArray = this.parentWorkflow.workflowInstance.formData['StepDocuments']?.['ServDocumentation']?.['documentsList'];

      let subDocArray: {}[] = [];
      if (this.parentWorkflow.workflowInstance.formData['StepDocuments']?.['DocumentationMandatory']?.['documentsList'])
        subDocArray = this.parentWorkflow.workflowInstance.formData['StepDocuments']?.['DocumentationMandatory']?.['documentsList'];

      let mandatoryFileAlreadyExists: boolean = false;
      let indexOfMandatoryFileEntry: number;

      //Ínicio Elementos clínicos
      this.InicioElementosClinicos(stepClinicalInfo, servDocArray, subDocArray);
      //Fim Elementos clínicos

      //Ínicio Declaração Situação na Segurança Social
      this.InicioDeclaracaoSituacaoSegurançaSocial(stepClinicalInfo, servDocArray, subDocArray);
      //Fim Declaração Situação na Segurança Social

      //Ínicio Atestado Períodos contribuições
      this.InicioAtestadoPeriodosContribuicoes(stepClinicalInfo, servDocArray, subDocArray);
      //Fim Atestado Períodos contribuições

      //Ínicio Atestado de incapacidade
      this.InicioAtestadoIncapacidade(stepClinicalInfo, servDocArray, subDocArray);
      //Fim Atestado de incapacidade

      //Ínicio Atestado de incapacidade dependentes
      // this.InicioAtestadoIncapacidadeDependentes(stepClinicalInfo, servDocArray, subDocArray):
      //Fim Atestado de incapacidade dependentes

      //Ínicio Comprovativo de IBAN
      this.InicioComprovativoIBAN(stepClinicalInfo, servDocArray, subDocArray);
      //Fim Comprovativo de IBAN

      //Ínicio Registo Biográfico
      this.InicioRegistoBiografico(stepClinicalInfo, servDocArray, subDocArray);
      //Fim Registo Biográfico

      //Ínicio Certificação do Tempo Docente
      this.InicioCertificacaoTempoDocente(stepClinicalInfo, servDocArray, subDocArray);
      //Fim Certificação do Tempo Docente

      let effMapEntries: models.EffectivityEntryVM[] = this.parentWorkflow.workflowInstance.formData['StepMap']?.['EffectivityMap']?.['effectivityList'];
      if (!effMapEntries)
        effMapEntries = [];

      //Ínicio Certidão do Tempo de Bombeiro Voluntário
      this.InicioCertidaoTempoBombeiroVoluntario(stepClinicalInfo, servDocArray, subDocArray, effMapEntries);
      //Fim Certidão do Tempo de Bombeiro Voluntário

      //Ínicio Certidão comprovativo SMO
      this.InicioCertidaoComprovativoSMO(stepClinicalInfo, servDocArray, subDocArray, effMapEntries);
      //Fim de Certidão comprovativa SMO"
    }
    var filtered = this.cardData.documentsList?.filter((doc, idx, arr) => {
      var isMandatoryFile = (doc.isMandatoryFile?.toString()?.toLowerCase() === 'true');
      if (isMandatoryFile) return true;
      if (doc.fileID != null && doc.fileID != undefined && doc.fileID != null && doc.fileID != "") return true;
      return false;
    });

    this.cardData.documentsList = filtered ?? [];

    // Mandatory lines that already have assosiated files
    this.initialMandatory = this.findInitialMandatory(this.cardData.documentsList) ?? [];


    this.readonlyAdditionalDoc = (this.isWorkflowOnSubscriber && !this.isMandatoryDocumentation && this.cardConfiguration.cardCode == "ServDocumentation") ||
      (this.cardConfiguration.cardCode == "ServDocumentation" && this.isWorkflowOnSubscriberAtendimento());

    this.showAddDocButton = !(this.parentWorkflow.isWorkflowOnSubscriber && this.cardConfiguration.cardCode === "ServDocumentation") ||
      (this.cardConfiguration.cardCode === "ServDocumentation" && this.PGPAS);

    // TEMP to prevent undefined errors if no stepdata is found
    if (isUndefined(this.cardData.documentsList))
      this.cardData.documentsList = [];

    //let mandatoryFileEntry: DocumentVMExtension = {
    //  description: "Atestado Períodos Contribuições - Proteção Social",
    //  designationTypeCode: "EBI060",
    //  extensionTypeCode: null,
    //  isMandatoryFile: true,
    //  name: null,
    //  observation: null,
    //  fileID: null,
    //  fileName: null,
    //  fileSizeKB: null,
    //  file: null,
    //  filePath: null
    //}
    //this.cardData.documentsList.push(mandatoryFileEntry);
  }

  isVersion2() {
    let result = false;
    if (this.parentWorkflow.workflowInstance.formData['Version']?.toString() === '2') {
      result = true;
    }
    return result;
  }

  checkSteps() {
    let result = false;
    for (let i = 0; i < this.parentWorkflow.steps.length; i++) {
      if (this.parentWorkflow.steps[i].stepCode === "StepSubscriberCGA") {
        result = true;
        break;
      }
    }
    return result;
  }

  isWorkflowCompulsoryAndOnService(): boolean {
    let isService = !this.isWorkflowOnSubscriber;
    let isCompulsory = !this.isVoluntary();

    return isService && isCompulsory;
  }

  isVoluntary(): boolean {
    let result = false;
    let voluntaryFundaments = ['PEDI001A', 'PEDI001B', 'PEDI001C', 'PEDI001D', 'PEDI001L', 'PEDI001F', 'PEDI001H', 'PEDI001I',
      'PEDI001K', 'PEDI001O', 'PEDI001P', 'PEDI001S', 'PEDI001T', 'PEDI001V', 'PEDI001X', 'PEDI001Y', 'PEDI001Z', 'PEDI001AB', 'PEDI001AC', 'PEDI001AD',
      'PEDI005A','PEDI005AD','PEDI005B' ,'PEDI005C' ,'PEDI005D' ,'PEDI005E' ,'PEDI005I' ,'PEDI005K' ,'PEDI005V' ,'PEDI005X'
    ];
    if (voluntaryFundaments.indexOf(this.parentWorkflow['workflowInstance']['workflowCode']) >= 0) {
      result = true;
    }

    return result;
  }

  public showDocRow(docItem: DocumentVMExtension) {
    let isMandatoryFile = (docItem.isMandatoryFile?.toString()?.toLowerCase() === 'true');
    if (isMandatoryFile) {
      return this.initialMandatory.find((v, i, a) => v === docItem) != undefined;
    }
    return true;
  }

  isWorkflowOnSubscriberAtendimento() {
    if (this.isAtendimento && !this.PGPAS)
      return true;
    else
      if (this.isAtendimento && this.PGPAS)
        return false;

    return false;
  }


  ngDoCheck(): void {
    //Needs to be done in DoCheck because of step data being received asyncrously
    if (isUndefined(this.cardData.documentsList))
      this.cardData.documentsList = [];
    if (isUndefined(this.version2)) {
      if (this.parentWorkflow) {
        this.version2 = this.parentWorkflow.workflowInstance.formData['Version']?.toString() === '2';
      }
    }
  }

  ngOnDestroy(): void {
  }

  public markAsMandatory(docItem: DocumentVMExtension): boolean {
    if (!this.isVersion2())
    return docItem.isMandatoryFile?.toString()?.toLowerCase() == 'true'
      && this.userSendingClinicalDocs?.toString()?.toLowerCase() == 'true';

    if (this.isVersion2()) {
      return docItem.isMandatoryFile?.toString()?.toLowerCase() == 'true';
    }
  }

  findInitialMandatory(docsList: DocumentVMExtension[]): DocumentVMExtension[] {
    if (!this.isVersion2()) {
      return docsList.filter((doc, idx, arr) => {
        // if not mandatory, distard it
        if (this.userSendingClinicalDocs) {
          if (doc.isMandatoryFile?.toString()?.toLowerCase() === 'true') return true;
        }
        // If no file associated, discard it too
        return (doc.fileID != null && doc.fileID != undefined && doc.fileID != null && doc.fileID != "");
      })
    }
    if (this.isVersion2()) {
      //return docsList.filter((doc, idx, arr) => {
      //  // if not mandatory, discard it
      //  if (this.userSendingClinicalDocs) {
      //    if (doc.isMandatoryFile?.toString()?.toLowerCase() === 'true') return true;
      //  } else if (this.userSendingSSRegisterDate) {
      //    if (doc.isMandatoryFile?.toString()?.toLowerCase() === 'true') return true;
      //  } else if (this.userSendingPensionsValue) {
      //    if (doc.isMandatoryFile?.toString()?.toLowerCase() === 'true') return true;
      //  } else if (this.userSendingDisability) {
      //    if (doc.isMandatoryFile?.toString()?.toLowerCase() === 'true') return true;
      //  } else if (this.userSendingPermanentDisability) {
      //    if (doc.isMandatoryFile?.toString()?.toLowerCase() === 'true') return true;
      //  } else if (this.userSendingIBAN) {
      //    if (doc.isMandatoryFile?.toString()?.toLowerCase() === 'true') return true;
      //  } else if (this.userSendingBiographicRegistry) {
      //    if (doc.isMandatoryFile?.toString()?.toLowerCase() === 'true') return true;
      //  } else if (this.userSendingTeacherCert) {
      //    if (doc.isMandatoryFile?.toString()?.toLowerCase() === 'true') return true;
      //  } else if (this.userSendingFiremenCert) {
      //    if (doc.isMandatoryFile?.toString()?.toLowerCase() === 'true') return true;
      //  } else if (this.userSendingMilitaryCert) {
      //    if (doc.isMandatoryFile?.toString()?.toLowerCase() === 'true') return true;
      //  }
      //  // If no file associated, discard it too
      //  return (doc.fileID != null && doc.fileID != undefined && doc.fileID != null && doc.fileID != "");
      //});
      let result = [];

      for (let i = 0; i < docsList.length; i++) {
        if (docsList[i].isMandatoryFile?.toString()?.toLowerCase() === 'true') {
          result.push(docsList[i])
        }
      }

      return result;
    }

  }

  onDocumentationChanged(newDocumentList: DocumentVMExtension[]) {

    // Refresh intitial mandatory list
    this.initialMandatory = this.findInitialMandatory(newDocumentList) ?? [];

    this.cardData.documentsList = newDocumentList;
    this.expandedRowIndex = null;
    this.expandNewEntry = false;

  }
  
  removeFromList(currentList: any[], indexToRemove: number, event: MouseEvent) {
    if (this.expandedRowIndex == null || this.expandedRowIndex == indexToRemove) {
      confirmRemoveFromList(currentList, indexToRemove, this.modalService).subscribe(result => {
        if (result)
          this.expandedRowIndex = null;
      });
    }
    event.stopPropagation();
  }

  expandRow(i) {
    if (this.expandedRowIndex == i)
      this.expandedRowIndex = null;
    else if (this.expandedRowIndex == null)
      this.expandedRowIndex = i;
  }


  InicioElementosClinicos(stepClinicalInfo: any, servDocArray: {}[], subDocArray: {}[]): ResultDocumentVM {
    //Ínicio Elementos clínicos
    let result: ResultDocumentVM = { mandatoryFileAlreadyExists: false, indexOfMandatoryFileEntry: null };
      this.userSendingClinicalDocs = (stepClinicalInfo?.['ClinicalSituation'] && ((this.parentWorkflow.isWorkflowOnSubscriber && !this.isAtendimento) || (this.isWorkflowOnSubscriberAtendimento()))) ||
        (stepClinicalInfo?.['ClinicalSituation']?.['clinicalSubscDoc']?.toString() === 'true' && ((!this.parentWorkflow.isWorkflowOnSubscriber && !this.isAtendimento) || (this.PGPAS && this.isAtendimento)));

      if (this.isWorkflowCompulsoryAndOnService()) {
        for (let i = 0; i < servDocArray.length; i++) {
          if (servDocArray[i]['designationTypeCode'] === "ECL000") {
            if (servDocArray[i]['isMandatoryFile'].toString() === 'true') {
              result.mandatoryFileAlreadyExists = true;
              result.indexOfMandatoryFileEntry = i;
            }
          }
        }
      }

      if (this.isWorkflowOnSubscriber || this.isWorkflowOnSubscriberAtendimento()) {
        for (let i = 0; i < subDocArray.length; i++) {
          if (subDocArray[i]['designationTypeCode'] === "ECL000") {
            if (subDocArray[i]['isMandatoryFile'].toString() === 'true') {
              result.mandatoryFileAlreadyExists = true;
              result.indexOfMandatoryFileEntry = i;
            }
          }
        }
      }

      if (this.userSendingClinicalDocs) {
        if (!result.mandatoryFileAlreadyExists) {
          let clinicalDoc: DocumentVMExtension = {
            description: "Elementos clínicos",
            designationTypeCode: "ECL000",
            extensionTypeCode: null,
            isMandatoryFile: true,
            name: null,
            observation: null,
            fileID: null,
            fileName: null,
            fileSizeKB: null,
            file: null,
            filePath: null
          }
          this.cardData.documentsList.push(clinicalDoc);
        }
      } else {
        if (result.mandatoryFileAlreadyExists) {
          this.cardData.documentsList.splice(result.indexOfMandatoryFileEntry, 1);
          result.mandatoryFileAlreadyExists = false;
        }
    }
    return result;
    //Fim Elementos clínicos

  }

  InicioDeclaracaoSituacaoSegurançaSocial(stepClinicalInfo: any, servDocArray: {}[], subDocArray: {}[]): ResultDocumentVM {
    //Ínicio Declaração Situação na Segurança Social
    const result: ResultDocumentVM = { mandatoryFileAlreadyExists: false, indexOfMandatoryFileEntry: undefined }
    if (!this.isWorkflowOnSubscriber) {
      this.userSendingSSRegisterDate = this.parentWorkflow.workflowInstance.formData?.StepSubscriberInfo?.['ExternalPensionStatus']?.['ssRegisterDate'] !== undefined;
      let privateTeachers = ['9', '35', '10', '34'];
      let isPrivateTeacher: boolean = false;

      let legalBases = ["15"];
      let hasLegalBase: boolean = false;

      if (!this.checkSteps()) {
        if (privateTeachers.indexOf(this.parentWorkflow.workflowInstance.formData?.['StepSubscriberInfo']?.['CGAPensionStatus']?.['professionalCategoryCode']) >= 0) {
          isPrivateTeacher = true;
        }
        if (legalBases.indexOf(this.parentWorkflow.workflowInstance.formData?.['StepSubscriberInfo']?.['CGAPensionStatus']?.['legalRetirementReason']) >= 0) {
          hasLegalBase = true;
        }
      } else {
        if (privateTeachers.indexOf(this.parentWorkflow.workflowInstance.formData?.['StepSubscriberCGA']?.['CGAPensionStatus']?.['professionalCategoryCode']) >= 0) {
          isPrivateTeacher = true;
        }
        if (legalBases.indexOf(this.parentWorkflow.workflowInstance.formData?.['StepSubscriberCGA']?.['CGAPensionStatus']?.['legalRetirementReason']) >= 0) {
          hasLegalBase = true;
        }
      }

      
      this.userSendingSSRegisterDate = isPrivateTeacher && hasLegalBase;

      for (let i = 0; i < servDocArray.length; i++) {
        if (servDocArray[i]['designationTypeCode'] === "MPP041") {
          if (servDocArray[i]['isMandatoryFile'].toString() === 'true') {
            result.mandatoryFileAlreadyExists = true;
            result.indexOfMandatoryFileEntry = i;
          }
        }
      }

      if (this.userSendingSSRegisterDate) {
        if (!result.mandatoryFileAlreadyExists) {
          let ssRegisterDoc: DocumentVMExtension = {
            description: "Declaração Situação na Segurança Social",
            designationTypeCode: "MPP041",
            extensionTypeCode: null,
            isMandatoryFile: true,
            name: null,
            observation: null,
            fileID: null,
            fileName: null,
            fileSizeKB: null,
            file: null,
            filePath: null
          }
          this.cardData.documentsList.push(ssRegisterDoc);
        }
      } else {
        if (result.mandatoryFileAlreadyExists) {
          this.cardData.documentsList.splice(result.indexOfMandatoryFileEntry, 1);
          result.mandatoryFileAlreadyExists = false;
        }
      }
    } else {
      if ((this.isWorkflowOnSubscriber || this.isWorkflowCompulsoryAndOnService() || !this.isWorkflowOnSubscriberAtendimento()) && this.parentWorkflow.workflowInstance.workflowCode === "PEDI001D") {
        let cgaRegisterDateplus16: Date;

        if (!this.checkSteps()) {
          cgaRegisterDateplus16 = new Date(this.parentWorkflow.workflowInstance.formData?.['StepSubscriberInfo']?.['CGAPensionStatus']?.['retirementTaxStartDate']);
        } else {
          cgaRegisterDateplus16 = new Date(this.parentWorkflow.workflowInstance.formData?.['StepSubscriberCGA']?.['CGAPensionStatus']?.['retirementTaxStartDate']);
        }

        cgaRegisterDateplus16.setFullYear(cgaRegisterDateplus16.getFullYear() + 16);

        this.userSendingSSRegisterDate = this.parentWorkflow.workflowInstance.formData?.['StepSubscriberInfo']?.['ExternalPensionStatus']?.hasUnifiedPension?.toString() === "false" && cgaRegisterDateplus16 <= new Date(Date.now());
        result.mandatoryFileAlreadyExists = false;
        result.indexOfMandatoryFileEntry = undefined;

        if (this.isWorkflowCompulsoryAndOnService()) {
          for (let i = 0; i < servDocArray.length; i++) {
            if (servDocArray[i]['designationTypeCode'] === "MPP041") {
              if (servDocArray[i]['isMandatoryFile'].toString() === 'true') {
                result.mandatoryFileAlreadyExists = true;
                result.indexOfMandatoryFileEntry = i;
              }
            }
          }
        }

        if (this.isWorkflowOnSubscriber || this.isWorkflowOnSubscriberAtendimento()) {
          for (let i = 0; i < subDocArray.length; i++) {
            if (subDocArray[i]['designationTypeCode'] === "MPP041") {
              if (subDocArray[i]['isMandatoryFile'].toString() === 'true') {
                result.mandatoryFileAlreadyExists = true;
                result.indexOfMandatoryFileEntry = i;
              }
            }
          }
        }

        if (this.userSendingSSRegisterDate) {
          if (!result.mandatoryFileAlreadyExists) {
            let mandatoryFileEntry: DocumentVMExtension = {
              description: "Declaração Situação na Segurança Social",
              designationTypeCode: "MPP041",
              extensionTypeCode: null,
              isMandatoryFile: true,
              name: null,
              observation: null,
              fileID: null,
              fileName: null,
              fileSizeKB: null,
              file: null,
              filePath: null
            }
            this.cardData.documentsList.push(mandatoryFileEntry);
          }

        } else {
          if (result.mandatoryFileAlreadyExists) {
            this.cardData.documentsList.splice(result.indexOfMandatoryFileEntry, 1);
            result.mandatoryFileAlreadyExists = false;
          }
        }
      }
    }
    return result;
      //Fim Declaração Situação na Segurança Social

  }

  InicioAtestadoPeriodosContribuicoes(stepClinicalInfo: any, servDocArray: {}[], subDocArray: {}[]): void {
    //Ínicio Atestado Períodos contribuições
    if (this.isWorkflowOnSubscriber || this.isWorkflowOnSubscriberAtendimento() || this.isWorkflowCompulsoryAndOnService()) {
      this.userSendingPensionsValue = this.parentWorkflow.workflowInstance.formData?.StepSubscriberInfo?.['ExternalPensionStatus']?.['otherSocialProtectionSchemes']?.toString() === "true" || this.parentWorkflow.workflowInstance.formData?.StepSubscriberInfo?.['ExternalPensionStatus']?.['workedAbroad']?.toString() === "true";

      let mandatoryFileAlreadyExists = false;
      let indexOfMandatoryFileEntry = undefined;

      if (this.isWorkflowCompulsoryAndOnService()) {
        for (let i = 0; i < servDocArray.length; i++) {
          if (servDocArray[i]['designationTypeCode'] === "EBI060") {
            if (servDocArray[i]['isMandatoryFile'].toString() === 'true') {
              mandatoryFileAlreadyExists = true;
              indexOfMandatoryFileEntry = i;
            }
          }
        }
      }

      if (this.isWorkflowOnSubscriber || this.isWorkflowOnSubscriberAtendimento()) {
        for (let i = 0; i < subDocArray.length; i++) {
          if (subDocArray[i]['designationTypeCode'] === "EBI060") {
            if (subDocArray[i]['isMandatoryFile'].toString() === 'true') {
              mandatoryFileAlreadyExists = true;
              indexOfMandatoryFileEntry = i;
            }
          }
        }
      }

      if (this.userSendingPensionsValue) {
        if (!mandatoryFileAlreadyExists) {
          let mandatoryFileEntry: DocumentVMExtension = {
            description: "Atestado Períodos Contribuições - Proteção Social",
            designationTypeCode: "EBI060",
            extensionTypeCode: null,
            isMandatoryFile: true,
            name: null,
            observation: null,
            fileID: null,
            fileName: null,
            fileSizeKB: null,
            file: null,
            filePath: null
          }
          this.cardData.documentsList.push(mandatoryFileEntry);
        }

      } else {
        if (mandatoryFileAlreadyExists) {
          this.cardData.documentsList.splice(indexOfMandatoryFileEntry, 1);
          mandatoryFileAlreadyExists = false;
        }
      }
    }
      //Fim Atestado Períodos contribuições
  }

  InicioAtestadoIncapacidadeDependentes(stepClinicalInfo: any, servDocArray: {}[], subDocArray: {}[]): void {
      //Ínicio Atestado de incapacidade dependentes
      if (this.isWorkflowOnSubscriber || this.isWorkflowCompulsoryAndOnService()) {
        this.userSendingPermanentDisability = this.parentWorkflow.workflowInstance.formData?.StepSubscriberInfo?.['SubscriberFiscalInformation']?.['dependentCountWithDisability']?.toString() > "0";

       let mandatoryFileAlreadyExists = false;
       let indexOfMandatoryFileEntry = undefined;

        for (let i = 0; i < servDocArray.length; i++) {
          if (servDocArray[i]['designationTypeCode'] === "MPF003") {
            if (servDocArray[i]['isMandatoryFile'].toString() === 'true') {
              mandatoryFileAlreadyExists = true;
              indexOfMandatoryFileEntry = i;
            }
          }
        }

        if (this.userSendingPermanentDisability) {
          if (!mandatoryFileAlreadyExists) {
            let mandatoryFileEntry: DocumentVMExtension = {
              description: "Atestado de incapacidade",
              designationTypeCode: "MPF003",
              extensionTypeCode: null,
              isMandatoryFile: true,
              name: null,
              observation: null,
              fileID: null,
              fileName: null,
              fileSizeKB: null,
              file: null,
              filePath: null
            }
            this.cardData.documentsList?.push(mandatoryFileEntry);
          }

        } else {
          if (mandatoryFileAlreadyExists) {
            this.cardData.documentsList?.splice(indexOfMandatoryFileEntry, 1);
            mandatoryFileAlreadyExists = false;
          }

          //let documentsServ;
          //if (this.isWorkflowCompulsoryAndOnService())
          //  documentsServ = this.parentWorkflow.workflowInstance.formData['StepDocuments']?.['ServDocumentation']?.['documentsList'];

          //if (this.isWorkflowOnSubscriber)
          //  documentsServ = this.parentWorkflow.workflowInstance.formData['StepDocuments']?.['DocumentationMandatory']?.['documentsList'];

          //if (documentsServ) {
          //  let indexOfDocToRemove;
          //  for (let i = 0; i < documentsServ.length; i++) {
          //    if (documentsServ[i]['designationTypeCode'] === "MPF003")
          //      indexOfDocToRemove = i;
          //  }
          //  documentsServ.splice(indexOfDocToRemove, 1);
          //}
        }
      }
      //Fim Atestado de incapacidade dependentes

  }

  InicioAtestadoIncapacidade(stepClinicalInfo: any, servDocArray: {}[], subDocArray: {}[]): void {
    if (this.isWorkflowOnSubscriber || this.isWorkflowOnSubscriberAtendimento() || this.isWorkflowCompulsoryAndOnService()) {
      if (this.parentWorkflow.workflowInstance.workflowCode.indexOf("PEDI0020") === -1) {
        this.userSendingDisability = this.parentWorkflow.workflowInstance.formData?.StepSubscriberInfo?.['SubscriberIdentification']?.['disability'] === "P" || this.parentWorkflow.workflowInstance.formData?.StepSubscriberInfo?.['SubscriberIdentification']?.['disability'] === "T";
        this.userSendingPermanentDisability = this.parentWorkflow.workflowInstance.formData?.StepSubscriberInfo?.['SubscriberFiscalInformation']?.['dependentCountWithDisability']?.toString() > "0";
      } else {
        this.userSendingDisability = false;
        this.userSendingPermanentDisability = false;
      }

      let mandatoryFileAlreadyExists = false;
      let indexOfMandatoryFileEntry = undefined;

      if (this.isWorkflowCompulsoryAndOnService()) {
        for (let i = 0; i < servDocArray.length; i++) {
          if (servDocArray[i]['designationTypeCode'] === "MPF003") {
            if (servDocArray[i]['isMandatoryFile'].toString() === 'true') {
              mandatoryFileAlreadyExists = true;
              indexOfMandatoryFileEntry = i;
            }
          }
        }
      }

      if (this.isWorkflowOnSubscriber || this.isWorkflowOnSubscriberAtendimento()) {
        for (let i = 0; i < subDocArray.length; i++) {
          if (subDocArray[i]['designationTypeCode'] === "MPF003") {
            if (subDocArray[i]['isMandatoryFile'].toString() === 'true') {
              mandatoryFileAlreadyExists = true;
              indexOfMandatoryFileEntry = i;
            }
          }
        }
      }

      if (this.userSendingDisability || this.userSendingPermanentDisability) {
        if (!mandatoryFileAlreadyExists) {
          let mandatoryFileEntry: DocumentVMExtension = {
            description: "Atestado de incapacidade",
            designationTypeCode: "MPF003",
            extensionTypeCode: null,
            isMandatoryFile: true,
            name: null,
            observation: null,
            fileID: null,
            fileName: null,
            fileSizeKB: null,
            file: null,
            filePath: null
          }
          this.cardData.documentsList.push(mandatoryFileEntry);
        }

      } else {
        if (mandatoryFileAlreadyExists) {
          this.cardData.documentsList.splice(indexOfMandatoryFileEntry, 1);
          mandatoryFileAlreadyExists = false;
        }
      }
    }
  }

  InicioComprovativoIBAN(stepClinicalInfo: any, servDocArray: {}[], subDocArray: {}[]): void {
    //Ínicio Comprovativo de IBAN
    if (this.isWorkflowOnSubscriber || this.isWorkflowOnSubscriberAtendimento() || this.isWorkflowCompulsoryAndOnService()) {
      this.userSendingIBAN = this.parentWorkflow.workflowInstance.formData?.StepSubscriberInfo?.['SubscriberPaymentInformation']?.['bankAccountTypeCode'] === "N" ||
        (this.parentWorkflow.workflowInstance.formData?.StepSubscriberInfo?.['SubscriberPaymentInformation']?.['bankAccountTypeCode'] === "I" &&
          this.parentWorkflow.workflowInstance.formData?.StepSubscriberInfo?.['SubscriberContacts']?.['countryCode'] === "PT");

      let mandatoryFileAlreadyExists = false;
      let indexOfMandatoryFileEntry = undefined;

      if (this.isWorkflowCompulsoryAndOnService()) {
        for (let i = 0; i < servDocArray.length; i++) {
          if (servDocArray[i]['designationTypeCode'] === "DPE051") {
            if (servDocArray[i]['isMandatoryFile'].toString() === 'true') {
              mandatoryFileAlreadyExists = true;
              indexOfMandatoryFileEntry = i;
            }
          }
        }
      }

      if (this.isWorkflowOnSubscriber || this.isWorkflowOnSubscriberAtendimento()) {
        for (let i = 0; i < subDocArray.length; i++) {
          if (subDocArray[i]['designationTypeCode'] === "DPE051") {
            if (subDocArray[i]['isMandatoryFile'].toString() === 'true') {
              mandatoryFileAlreadyExists = true;
              indexOfMandatoryFileEntry = i;
            }
          }
        }
      }

      if (this.userSendingIBAN) {
        if (!mandatoryFileAlreadyExists) {
          let mandatoryFileEntry: DocumentVMExtension = {
            description: "Comprovativo de IBAN",
            designationTypeCode: "DPE051",
            extensionTypeCode: null,
            isMandatoryFile: true,
            name: null,
            observation: null,
            fileID: null,
            fileName: null,
            fileSizeKB: null,
            file: null,
            filePath: null
          }
          this.cardData.documentsList.push(mandatoryFileEntry);
        }

      } else {
        if (mandatoryFileAlreadyExists) {
          this.cardData.documentsList.splice(indexOfMandatoryFileEntry, 1);
          mandatoryFileAlreadyExists = false;
        }
      }
    }
      //Fim Comprovativo de IBAN

  }

  InicioRegistoBiografico(stepClinicalInfo: any, servDocArray: {}[], subDocArray: {}[]): void {
    //Ínicio Registo Biográfico
    if (!this.isWorkflowOnSubscriber) {
      let publicTeachers = ['32', '7', '6'];
      if (this.checkSteps()) {
        this.userSendingBiographicRegistry = publicTeachers.indexOf(this.parentWorkflow.workflowInstance.formData?.StepSubscriberCGA?.['CGAPensionStatus']?.['professionalCategoryCode']) >= 0;
      } else {
        this.userSendingBiographicRegistry = publicTeachers.indexOf(this.parentWorkflow.workflowInstance.formData?.StepSubscriberInfo?.['CGAPensionStatus']?.['professionalCategoryCode']) >= 0;
      }

      let mandatoryFileAlreadyExists = false;
      let indexOfMandatoryFileEntry = undefined;

      for (let i = 0; i < servDocArray.length; i++) {
        if (servDocArray[i]['designationTypeCode'] === "EBI003") {
          if (servDocArray[i]['isMandatoryFile'].toString() === 'true') {
            mandatoryFileAlreadyExists = true;
            indexOfMandatoryFileEntry = i;
          }
        }
      }

      if (this.userSendingBiographicRegistry) {
        if (!mandatoryFileAlreadyExists) {
          let mandatoryFileEntry: DocumentVMExtension = {
            description: "Registo Biográfico",
            designationTypeCode: "EBI003",
            extensionTypeCode: null,
            isMandatoryFile: true,
            name: null,
            observation: null,
            fileID: null,
            fileName: null,
            fileSizeKB: null,
            file: null,
            filePath: null
          }
          this.cardData.documentsList.push(mandatoryFileEntry);
        }

      } else {
        if (mandatoryFileAlreadyExists) {
          this.cardData.documentsList.splice(indexOfMandatoryFileEntry, 1);
          mandatoryFileAlreadyExists = false;
        }
      }
    }
      //Fim Registo Biográfico

  }

  InicioCertificacaoTempoDocente(stepClinicalInfo: any, servDocArray: {}[], subDocArray: {}[]): void {
    //Ínicio Certificação do Tempo Docente
    if (!this.isWorkflowOnSubscriber) {
      let privateteachers = ['9', '35', '10', '34'];

      if (this.checkSteps()) {
        this.userSendingTeacherCert = privateteachers.indexOf(this.parentWorkflow.workflowInstance.formData.StepSubscriberCGA?.['CGAPensionStatus']?.['professionalCategoryCode']) >= 0;
      } else {
        this.userSendingTeacherCert = privateteachers.indexOf(this.parentWorkflow.workflowInstance.formData.StepSubscriberInfo?.['CGAPensionStatus']?.['professionalCategoryCode']) >= 0;
      }

      if (this.userSendingTeacherCert === false) {
        let effMapEntries: models.EffectivityEntryVM[] = this.parentWorkflow.workflowInstance.formData['StepMap']?.['EffectivityMap']?.['effectivityList'];

        for (let i = 0; i <= effMapEntries.length; i++) {
          if (effMapEntries[i]?.entityCode === "9" && effMapEntries[i]?.subscriberSituationCode === "ENPA") {
            this.userSendingTeacherCert = true;
            break;
          }
        }

      }

      let mandatoryFileAlreadyExists = false;
      let indexOfMandatoryFileEntry = undefined;

      for (let i = 0; i < servDocArray.length; i++) {
        if (servDocArray[i]['designationTypeCode'] === "EBI014") {
          if (servDocArray[i]['isMandatoryFile'].toString() === 'true') {
            mandatoryFileAlreadyExists = true;
            indexOfMandatoryFileEntry = i;
          }
        }
      }

      if (this.userSendingTeacherCert) {
        if (!mandatoryFileAlreadyExists) {
          let mandatoryFileEntry: DocumentVMExtension = {
            description: "Certificação do Tempo Docente (Ensino Particular e Cooperativo)",
            designationTypeCode: "EBI014",
            extensionTypeCode: null,
            isMandatoryFile: true,
            name: null,
            observation: null,
            fileID: null,
            fileName: null,
            fileSizeKB: null,
            file: null,
            filePath: null
          }
          this.cardData.documentsList.push(mandatoryFileEntry);
        }

      } else {
        if (mandatoryFileAlreadyExists) {
          this.cardData.documentsList.splice(indexOfMandatoryFileEntry, 1);
          mandatoryFileAlreadyExists = false;
        }
      }
    }
      //Fim Certificação do Tempo Docente

  }

  InicioCertidaoTempoBombeiroVoluntario(stepClinicalInfo: any, servDocArray: {}[], subDocArray: {}[], effMapEntries: {}[]): void {
    //Ínicio Certidão do Tempo de Bombeiro Voluntário
    if (!this.isWorkflowOnSubscriber) {
      let firemenBonus = ['100', '101', '102'];
      let canBeVolFireman = this.professionalClass !== "1" && this.professionalClass !== "2";
      let hasVolFiremanBonus: boolean = false;

      for (let i = 0; i < effMapEntries.length; i++) {
        if (effMapEntries[i]['timeIncrease'] !== undefined && effMapEntries[i]['timeIncrease']?.toString() === "true") {
          if (firemenBonus.indexOf(effMapEntries[i]['bonus']?.toString()) >= 0) {
            hasVolFiremanBonus = true;
            break;
          }
        }
      }

      this.userSendingFiremenCert = canBeVolFireman && hasVolFiremanBonus;

      let mandatoryFileAlreadyExists = false;
      let indexOfMandatoryFileEntry = undefined;

      for (let i = 0; i < servDocArray.length; i++) {
        if (servDocArray[i]['designationTypeCode'] === "EBI013") {
          if (servDocArray[i]['isMandatoryFile'].toString() === 'true') {
            mandatoryFileAlreadyExists = true;
            indexOfMandatoryFileEntry = i;
          }
        }
      }

      if (this.userSendingFiremenCert) {
        if (!mandatoryFileAlreadyExists) {
          let mandatoryFileEntry: DocumentVMExtension = {
            description: "Certidão do Tempo de Bombeiro Voluntário (ANPC)",
            designationTypeCode: "EBI013",
            extensionTypeCode: null,
            isMandatoryFile: true,
            name: null,
            observation: null,
            fileID: null,
            fileName: null,
            fileSizeKB: null,
            file: null,
            filePath: null
          }
          this.cardData.documentsList.push(mandatoryFileEntry);
        }
      } else {
        if (mandatoryFileAlreadyExists) {
          this.cardData.documentsList.splice(indexOfMandatoryFileEntry, 1);
          mandatoryFileAlreadyExists = false;
        }
      }
    }
      //Fim Certidão do Tempo de Bombeiro Voluntário

  }

  InicioCertidaoComprovativoSMO(stepClinicalInfo: any, servDocArray: {}[], subDocArray: {}[], effMapEntries: any[]): void {

    //Ínicio Certidão comprovativo SMO
    if (!this.isWorkflowOnSubscriber) {
      let hasMandatoryMilitaryService: boolean = false;

      for (let i = 0; i < effMapEntries.length; i++) {
        if (effMapEntries[i].subscriberSituationCode === 'SMOB') {
          hasMandatoryMilitaryService = true;
          break;
        }
      }

       let mandatoryFileAlreadyExists = false;
       let indexOfMandatoryFileEntry = undefined;

      this.userSendingMilitaryCert = hasMandatoryMilitaryService;

      for (let i = 0; i < servDocArray.length; i++) {
        if (servDocArray[i]['designationTypeCode'] === "EBI012") {
          if (servDocArray[i]['isMandatoryFile'].toString() === 'true') {
            mandatoryFileAlreadyExists = true;
            indexOfMandatoryFileEntry = i;
          }
        }
      }

      if (this.userSendingMilitaryCert) {
        if (!mandatoryFileAlreadyExists) {
          let militaryServiceDoc: DocumentVMExtension = {
            description: "Certidão comprovativa SMO",
            designationTypeCode: "EBI012",
            extensionTypeCode: null,
            isMandatoryFile: true,
            name: null,
            observation: null,
            fileID: null,
            fileName: null,
            fileSizeKB: null,
            file: null,
            filePath: null
          }
          this.cardData.documentsList.push(militaryServiceDoc);
        }
      } else {
        if (mandatoryFileAlreadyExists) {
          this.cardData.documentsList.splice(indexOfMandatoryFileEntry, 1);
          mandatoryFileAlreadyExists = false;
        }
      }
    }
  
    //Fim de Certidão comprovativa SMO"

  }
}
